import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

export default function SportDateTabs({
  selectedDate,
  onDateChange,
}) {
  const today = dayjs().tz(TZ);
  const tabs = [
    { value: "live", label: "Kèo trực tuyến", live: true },
    { value: today.format("YYYY-MM-DD"), label: "Hôm nay" },
    {
      value: today.add(1, "day").format("YYYY-MM-DD"),
      label: "Ngày mai",
    },
    ...Array.from({ length: 5 }, (_, i) => {
      const d = today.add(i + 2, "day");
      return { value: d.format("YYYY-MM-DD"), label: d.format("DD/MM") };
    }),
  ];

  return (
    <div className="date-tabs">
      {tabs.map((tab) => {
        const active = selectedDate === tab.value;
        return (
          <div
            key={tab.value}
            role="button"
            tabIndex={0}
            className={`tab-button${tab.live ? " tab-btn-live" : ""}${
              active ? " active" : ""
            }`}
            onClick={() => onDateChange?.(tab.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onDateChange?.(tab.value);
              }
            }}
          >
            {tab.live ? <i className="home_filterbar-live red" /> : null}
            <span>{tab.label}</span>
          </div>
        );
      })}
    </div>
  );
}
